export default __webpack_public_path__ + "static/media/keyboard_key_2.b103cf02.png";